import styled, { css } from 'styled-components';

import { PriceComparison } from '../../hooks/contexts/resale-listing.pricing';

/*
 * Badge sm "Pill color" (Figma 16677-57204), no icon. Colors come from the
 * Figma palette (Blue / Gray / Warning) and aren't in the theme: hardcoded
 * on purpose, matching lp-revenda.
 */
const VARIANTS: Record<PriceComparison, ReturnType<typeof css>> = {
  below : css`
    border-color: #BFDBFE;
    background-color: #EFF6FF;
    color: #1D4ED8;
  `,
  equal : css`
    border-color: #E5E5E5;
    background-color: #FAFAFA;
    color: #404040;
  `,
  above : css`
    border-color: #FEF08A;
    background-color: #FEFCE8;
    color: #A16207;
  `,
};

export const Badge = styled.span<{ $variant: PriceComparison }>`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
  ${({ $variant }) => VARIANTS[$variant]}
`;
